const EVENT_DELAY = 3000;

export const dispatchWorkflowCompleteEvent = (skipped) => {
  const message = { status: 'WORKFLOW_COMPLETE' };
  if (skipped) message.skipped = true;
  window.parent.postMessage(message, '*');
};

export const redirectToExternalURL = (url) => {
  setTimeout(() => {
    window.location = url;
  }, EVENT_DELAY);
};
